import { render, staticRenderFns } from "./DocusignAdditionalDocumentManagement.vue?vue&type=template&id=7c444e5e&"
import script from "./DocusignAdditionalDocumentManagement.vue?vue&type=script&lang=ts&"
export * from "./DocusignAdditionalDocumentManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports